import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function PlusOneCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    PlaySound('booster-five-cards-use');

    const targetCards: BaseCard[] = taskData.cards.map((targetCardID: string) =>
        system.getCardByID(targetCardID)
    );

    // Hide target cards initially.
    for (let card of targetCards) {
        card.getComponent(Renderable).visible = false;
    }

    const plusOneAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(plusOneAnimator);

    const task = new CardAnimationTask(
        taskData,
        system,
        'CardPlusOne',
        plusOneAnimator,
        {
            targetCards: targetCards,
            stackContainer: system.stackContainer,
        }
    );

    task.animationClip.on('PlusOneCardAdded', () => {
        system.cardStack.update();
    });

    system.taskQueue.queue(task);
}
